import { useEffect, useMemo, useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $usersAccountStore } from '@lib/store';
import { UserType } from '@shared/api';
import { ManagerList } from './managerList';
import { AddManagerModal } from './addManagersModal';
import { RemoveManagerModal } from './removeManagerModal';
import { View } from '@widgets';
import { Button, Text } from '@shared/widgets';

interface ManagersProps {
  accountId: number;
}

export const Managers = (props: ManagersProps) => {
  const managersStore = useUnit($usersAccountStore.store);

  const [showAddMangerModal, setShowAddMangerModal] = useState<boolean>(false);
  const [showRemoveManagerModal, setShowRemoveManagerModal] = useState<boolean>(false);

  const { t } = useTranslation('account');

  useEffect(() => {
    $usersAccountStore.events.getAccountUsers({ UserType: UserType.Manager });
    return () => $usersAccountStore.events.clear();
  }, []);

  const closeAddModal = (confirm?: boolean) => {
    setShowAddMangerModal(false);
    if (confirm) $usersAccountStore.events.getAccountUsers({ UserType: UserType.Manager });
  };
  const closeRemoveModal = (confirm?: boolean) => {
    setShowRemoveManagerModal(false);
    if (confirm) $usersAccountStore.events.getAccountUsers({ UserType: UserType.Manager });
  };

  const managers = useMemo(
    () => managersStore.data.filter((manager) => manager.accounts.includes(props.accountId)),
    [props.accountId, managersStore.data],
  );
  return (
    <>
      <div className='flex flex-col gap-6'>
        <div className='flex w-full items-center justify-between overflow-x-auto'>
          <Text weight='semibold' size='2xl'>
            {t('managers.title')}
          </Text>
          <div className='flex gap-2'>
            <Button color='outlined' onClick={() => setShowAddMangerModal(true)}>
              {t('buttons.add', { ns: 'common' })}
            </Button>
            <Button color='outlined' onClick={() => setShowRemoveManagerModal(true)}>
              {t('buttons.remove', { ns: 'common' })}
            </Button>
          </div>
        </div>
        <View
          loading={managersStore.loading}
          error={managersStore.error}
          onRefresh={() => $usersAccountStore.events.getAccountUsers({ UserType: UserType.Manager })}
          noData={!managers.length}
        >
          <ManagerList data={managers} />
        </View>
      </div>
      <AddManagerModal
        isOpen={showAddMangerModal}
        onClose={closeAddModal}
        accountId={props.accountId}
        data={managersStore.data.filter((m) => !m.accounts.includes(props.accountId))}
      />
      <RemoveManagerModal isOpen={showRemoveManagerModal} onClose={closeRemoveModal} accountId={props.accountId} data={managers} />
    </>
  );
};
